<template>
  <b-modal
    id="viewfilledfbckform"
    centered
    hide-footer
    hide-header
    class="p-0"
    size="lg"
    no-close-on-backdrop
    @hidden="context.$bvModal.hide('viewfilledfbckform')"
  >
    <div class="previewfdbck-modalheading d-flex align-items-center"></div>
    <div
      :style="isLaptop ? '' : 'right:15px;top:15px;'"
      @click="context.$bvModal.hide('viewfilledfbckform')"
      class="xMarkCancel"
    >
      <img v-if="isLaptop" src="../../../assets/xmark.svg" alt="" />

      <img v-else src="../../../assets/whiteCross-1.svg" alt="" />
    </div>
    <div class="prfdbck-name-box">Preview Feedback Form</div>

    <!-- modal body start -->
    <div class="previewfdbck-container">
      <div class="pfdbck-bi-heading">Basic Info</div>

      <div class="viewFeedback">
        <b-row>
          <b-col>
            <div class="topDiv mt-3">
              <label class="fieldsetStyle">Candidate Name</label>
              <b-form-input
                class="previewfdbckinput"
                v-model="context.candidateDetails.name"
                disabled
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv mt-3">
              <label class="fieldsetStyle">Evaluation Date</label>
              <b-form-input
                class="previewfdbckinput"
                v-model="context.candidateDetails.evalDate"
                disabled
              >
              </b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="topDiv mt-3">
              <label class="fieldsetStyle">Panel Name</label>
              <b-form-input
                placeholder="Not disclosed"
                class="previewfdbckinput"
                v-model="context.candidateDetails.panel"
                disabled
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="topDiv mt-3">
              <label class="fieldsetStyle">Experience (In years)</label>
              <b-form-input
                placeholder="Not disclosed"
                class="previewfdbckinput"
                v-model="context.candidateDetails.experience"
                disabled
              >
              </b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="topDiv mt-3">
              <label class="fieldsetStyle"
                >Mode Of Interview (Web CAM / T-Com)</label
              >
              <b-form-input
                class="previewfdbckinput"
                v-model="context.candidateDetails.modeOfInterview"
                style="text-transform: capitalize"
                disabled
              >
              </b-form-input>
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        class="mt-3 prfdbck-skill-container"
        v-for="(input, k) in context.filledfdbckform.skills"
        :key="k"
      >
        <div class="pfdbck-bi-heading">
          {{ input.name }}
        </div>

        <div class="candviewmodalinput" v-if="input.markingType == 'rating'">
          <label class="mt-2 formtext-value">Rating</label>
          <b-form-rating
            variant="primary"
            v-model="input.mark"
            class="mb-2 scorerate p-0 w-25"
            disabled
          ></b-form-rating>
        </div>

        <div class="mt-2" v-if="input.markingType == 'score'">
          <b-row>
            <b-col>
              <div class="topDiv mt-3">
                <label class="fieldsetStyle">Score</label>
                <b-form-input
                  class="previewfdbckinput"
                  v-model="input.mark"
                  disabled
                >
                  Score will be given from 1 - 10
                </b-form-input>
              </div>
            </b-col>
          </b-row>
        </div>

        <div class="mt-2" v-if="input.commentMode == true">
          <div class="topDiv mt-3">
            <label class="fieldsetStyle">Comments</label>
            <b-form-textarea
              class="previewfdbckinput"
              v-model="input.comments"
              disabled
              rows="3"
              max-rows="4"
            >
            </b-form-textarea>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div class="pfdbck-bi-heading">Screenshot</div>
        <div
          class="
            prfdbck-skill-container
            d-flex
            align-items-center
            justify-content-center
            h-100
            w-100
          "
          style="height: 500px"
        >
          <div
            class="pr-sstxt h-100 w-100"
            v-if="context.filledfdbckform.screenshotMedia"
          >
            <img
              :src="context.filledfdbckform.screenshotMedia"
              class="w-100 h-100"
              alt=""
            />
          </div>
          <div class="pr-sstxt" v-else>No Screenshot Provided</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getDate } from "../../../controllers/JD/helpers.js";
export default {
  name: "ViewFeedback",
  props: {
    context: Object,
  },
  data() {
    return {
      getCurrentDate: "",
      isLaptop: true,
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  created() {
    this.getDate();
  },

  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    getDate() {
      getDate(this);
    },
  },
};
</script>
<style>
#viewfilledfbckform .modal-body {
  padding: 0px;
}
</style>
